/* eslint no-param-reassign: ["error", { "props": false }] */

import deepmerge from 'deepmerge';

class JsonService {
    static fetchDataJson = async url => {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
        });

        const jsonResponse = response.json();

        return jsonResponse;
    };

    static refactorPropertiesToValues = data => {
        const newData = data;

        newData.map(element => {
            const objectWithValues = element;

            Object.keys(element).forEach(key => {
                const objectElement = element[key];

                if (key !== "id") {
                    if (Array.isArray(objectElement)) {
                        element[key] = JsonService.refactorPropertiesToValues(
                            objectElement
                        );
                    }

                    objectWithValues.values = element[key];
                    delete objectWithValues[key];
                }

                return false;
            });

            return objectWithValues;
        });

        return newData;
    };

    static mergeJsons = (config, data) => {
        const emptyTarget = value => (Array.isArray(value) ? [] : {});
        const clone = (value, options) => deepmerge(emptyTarget(value), value, options);

        const combineMerge = (target, source, options) => {
            const destination = target.slice();

            source.forEach((e, i) => {
                if (typeof destination[i] === 'undefined') {
                    const cloneRequested = options.clone !== false;
                    const shouldClone = cloneRequested && options.isMergeableObject(e);

                    destination[i] = shouldClone ? clone(e, options) : e;
                } else if (options.isMergeableObject(e)) {
                    destination[i] = deepmerge(target[i], e, options);
                } else if (target.indexOf(e) === -1) {
                    destination.push(e);
                }
            });

            return destination;
        };

        return deepmerge(
            config,
            data,
            { arrayMerge: combineMerge },
        );
    };
}

export default JsonService;
